
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 13.755a23.931 23.931 0 01-9 1.745c-3.183 0-6.22-.62-9-1.745M16 6.5v-2a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20.5h14a2 2 0 002-2v-10a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    